import { useState, useEffect } from "react";

const faqs = [
  {
    id: "faq-1",
    question: "Что такое «белая таможня» и почему это важно для B2B-импорта из Китая?",
    answer:
      "«Белая таможня» означает полностью легальное таможенное оформление с официальной грузовой таможенной декларацией (ГТД) и уплатой всех пошлин и НДС. Все поставки Chirunnexa проходят через официальных таможенных брокеров: вы получаете ГТД, счёт-фактуру с НДС и полный пакет документов для бухгалтерии. Никаких серых схем — только прозрачная логистика.",
  },
  {
    id: "faq-2",
    question: "Что такое ГТД и НДС при импорте автозапчастей из КНР?",
    answer:
      "ГТД (Грузовая Таможенная Декларация) — официальный документ, подтверждающий законный ввоз товара на территорию ЕАЭС. НДС при импорте уплачивается на таможне и подлежит вычету для юридических лиц на ОСНО. Chirunnexa предоставляет полный пакет: ГТД, CMR, инвойс, упаковочный лист и сертификаты EAC — всё необходимое для налогового учёта.",
  },
  {
    id: "faq-3",
    question: "Что такое сертификация EAC и обязательна ли она для автозапчастей?",
    answer:
      "EAC (Евразийское соответствие) — обязательная сертификация для ввоза автокомпонентов на рынок ЕАЭС (Россия, Беларусь, Казахстан и др.). Без EAC-маркировки продажа запчастей в России незаконна. Все поставляемые нами компоненты BMW, VAG, JLR и масла Shell имеют действующие сертификаты EAC и декларации соответствия.",
  },
  {
    id: "faq-4",
    question: "Как Chirunnexa гарантирует оригинальность масел Shell из Гонконга?",
    answer:
      "Масла Shell поставляются напрямую от официального дистрибьютора в Гонконге с полным пакетом документов: сертификат подлинности Shell, COA (Certificate of Analysis), инвойс дистрибьютора и EAC-декларация. Каждая партия проходит входной контроль на складе YAXIN в Гуанчжоу. Мы не работаем с параллельным импортом без документов.",
  },
  {
    id: "faq-5",
    question: "Какой минимальный заказ (MOQ) для B2B-поставки?",
    answer:
      "Минимальный заказ — от 1 паллеты (≈ 500–800 кг) для сборных грузов (LCL). Для полноконтейнерных поставок (FCL 20'/40') действуют специальные оптовые цены. Мы работаем с дистрибьюторами, автосервисами и оптовыми складами по всей России — от Москвы до Владивостока.",
  },
  {
    id: "faq-6",
    question: "Какие сроки доставки из Китая в Россию?",
    answer:
      "Стандартные сроки: авиа — 5–10 рабочих дней, ж/д (Китай–Россия) — 18–25 дней, морской контейнер — 35–45 дней. Мы работаем через 15 логистических узлов в КНР (Гуанчжоу, Шанхай, Ухань, Чэнду и др.) и собственный склад в Москве (ООО «ЯСИН РУС»). Срочные поставки — авиа из Гуанчжоу.",
  },
  {
    id: "faq-7",
    question: "Как работает система рекламаций «Умная рекламация: Списание на месте»?",
    answer:
      "При обнаружении брака вам не нужно возвращать товар в Китай. Наша система «Умная рекламация»: вы фотографируете дефект, отправляете нам акт, мы утилизируете товар на месте и выставляем кредит-ноту или отправляем замену следующей партией. Это экономит время и логистические расходы — стандарт для B2B-партнёров Chirunnexa.",
  },
];

export default function FAQSection() {
  const [openId, setOpenId] = useState<string | null>(null);

  const toggle = (id: string) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  // Inject Schema.org FAQPage JSON-LD
  useEffect(() => {
    const existing = document.getElementById("faq-schema");
    if (existing) existing.remove();

    const script = document.createElement("script");
    script.id = "faq-schema";
    script.type = "application/ld+json";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqs.map((faq) => ({
        "@type": "Question",
        "name": faq.question,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": faq.answer,
        },
      })),
    });
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById("faq-schema");
      if (el) el.remove();
    };
  }, []);

  return (
    <section id="faq" className="bg-[#060A12] py-24">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-[2px] bg-[#C9A84C]"></div>
              <span className="text-[#C9A84C] text-xs font-semibold tracking-[0.3em] uppercase">Частые вопросы</span>
            </div>
            <h2
              className="text-white"
              style={{
                fontFamily: "'Bebas Neue', sans-serif",
                fontSize: "clamp(32px, 4vw, 56px)",
                letterSpacing: "0.03em",
                lineHeight: 1.1,
              }}
            >
              БЕЛАЯ ТАМОЖНЯ,<br />
              <span className="text-[#C9A84C]">ГТД/НДС И EAC</span>
            </h2>
          </div>
          <p className="text-gray-400 text-sm leading-relaxed max-w-md lg:text-right">
            Ответы на ключевые вопросы о легальном импорте автозапчастей и масел Shell из КНР. Полная прозрачность для вашего бизнеса.
          </p>
        </div>

        {/* FAQ Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 border border-[#1E2A3A]">
          {faqs.map((faq, idx) => {
            const isOpen = openId === faq.id;
            const isLeft = idx % 2 === 0;
            return (
              <div
                key={faq.id}
                className={`border-b border-[#1E2A3A] ${isLeft ? "lg:border-r" : ""} transition-colors duration-200 ${
                  isOpen ? "bg-[#0D1420]" : "bg-transparent hover:bg-[#0A0F1A]"
                }`}
              >
                <button
                  onClick={() => toggle(faq.id)}
                  className="w-full text-left px-6 py-6 flex items-start gap-4 cursor-pointer group"
                  aria-expanded={isOpen}
                >
                  {/* Number */}
                  <span
                    className="text-[#C9A84C]/40 font-bold text-xs mt-1 flex-shrink-0 w-6"
                    style={{ fontFamily: "'Oswald', sans-serif" }}
                  >
                    {String(idx + 1).padStart(2, "0")}
                  </span>
                  {/* Question */}
                  <span
                    className={`flex-1 text-sm font-semibold leading-snug transition-colors duration-200 ${
                      isOpen ? "text-[#C9A84C]" : "text-white group-hover:text-[#C9A84C]"
                    }`}
                    style={{ fontFamily: "'Oswald', sans-serif", letterSpacing: "0.02em" }}
                  >
                    {faq.question}
                  </span>
                  {/* Toggle icon */}
                  <div
                    className={`w-6 h-6 flex items-center justify-center flex-shrink-0 border transition-all duration-300 rounded-sm mt-0.5 ${
                      isOpen
                        ? "border-[#C9A84C] bg-[#C9A84C]/10 rotate-45"
                        : "border-[#1E2A3A] group-hover:border-[#C9A84C]/50"
                    }`}
                  >
                    <i className={`ri-add-line text-[#C9A84C] text-xs`}></i>
                  </div>
                </button>

                {/* Answer */}
                <div
                  className={`overflow-hidden transition-all duration-300 ease-in-out ${
                    isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
                  }`}
                >
                  <div className="px-6 pb-6 pl-16">
                    <p className="text-gray-400 text-sm leading-relaxed border-l-2 border-[#C9A84C]/30 pl-4">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-6 bg-[#0D1420] border border-[#C9A84C]/20 px-8 py-6 rounded-sm">
          <div className="flex items-center gap-4">
            <div className="w-10 h-10 flex items-center justify-center bg-[#C9A84C]/10 border border-[#C9A84C]/30 rounded-sm flex-shrink-0">
              <i className="ri-question-answer-line text-[#C9A84C] text-base"></i>
            </div>
            <div>
              <div className="text-white text-sm font-semibold">Остались вопросы?</div>
              <div className="text-gray-400 text-xs mt-0.5">
                Напишите на <strong className="text-[#C9A84C]">eagle_parts@vk.com</strong> — MAX ответит в течение 24 часов
              </div>
            </div>
          </div>
          <a
            href="#contact"
            className="flex items-center gap-2 bg-[#C9A84C] hover:bg-[#b8943d] text-[#0A0F1A] font-bold text-sm px-6 py-3 rounded-sm tracking-wide uppercase transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-file-list-3-line text-base"></i>
            Запросить прайс-лист
          </a>
        </div>
      </div>
    </section>
  );
}
